import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Hero from './components/Hero';
import MarketProspect from './components/MarketProspect';
import BusinessModel from './components/BusinessModel';
import InvestmentLogic from './components/InvestmentLogic';
import Cooperation from './components/Cooperation';
import Cta from './components/Cta';

export default function Invest() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="投资关系 | 共建乡村数字经济人工智能应用体系"
        description="了解九畴云市市场前景、商业模式、投资逻辑与合作方式，诚邀投资人与产业伙伴共建乡村数字商业基础设施。"
        keywords="投资关系,商业模式,投资逻辑,乡村数字经济,九畴云市"
        path="/about/investor-relations"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '投资关系',
          description: '共建乡村数字经济人工智能应用体系',
        }}
      />
      <main>
        <Hero />
        <Breadcrumb items={[{ label: '关于我们' }, { label: '投资关系' }]} />
        <MarketProspect />
        <BusinessModel />
        <InvestmentLogic />
        <Cooperation />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}